<template>
  <div :class="$style['wrapper']">
    <ds-content-header>
      <div slot="left">
        <ds-breadcrumbs :breadcrumbs="breadcrumbs" />
      </div>
    </ds-content-header>
    <div class="columns">
      <div class="column is-6">
        <ds-content-box>
          <div
            slot="header"
            class="content-header"
          >
            <span class="content-title">
              Wygeneruj hasło htpasswd
            </span>
          </div>
          <div slot="content">
            <htpasswd-generator-form @onSubmit="onSubmit" />
          </div>
        </ds-content-box>
      </div>
    </div>

    <div
      v-if="isFetching || generatedPassword || fetchingError"
      class="columns"
    >
      <div class="column is-6">
        <ds-content-box>
          <div
            slot="header"
            class="content-header"
          >
            <span class="content-title">
              Wpis do .htpasswd
            </span>
          </div>
          <div slot="content">
            <div class="gray-background-inner">
              <ds-loader
                :is-loading="isFetching"
                full-height
              >
                <div
                  :class="$style['password-response-box']"
                  class="input-box"
                >
                  <div :class="$style['result-wrapper']">

                    <div>
                      <ds-label class="dark-label">
                        <span slot="content">
                          Użytkownik
                        </span>
                      </ds-label>
                      <div :class="$style['copy-inp-wrapper']">
                        <ds-input
                          :value="username"
                          :show-error-box="false"
                          read-only
                        />
                        <ds-button @click="onCopy(username)">SKOPIUJ DO SCHOWKA</ds-button>
                      </div>
                    </div>

                    <div>
                      <ds-label class="dark-label">
                        <span slot="content">
                          Hasło
                        </span>
                      </ds-label>
                      <div :class="$style['copy-inp-wrapper']">
                        <ds-input
                          :value="userPassword.data"
                          :show-error-box="false"
                          type="password"
                          read-only
                          peek-field
                        />
                        <ds-button @click="onCopy(userPassword.data)">SKOPIUJ DO SCHOWKA</ds-button>
                      </div>
                    </div>

                    <div>
                      <ds-label class="dark-label">
                        <span slot="content">
                          Wpis do .htpasswd
                        </span>
                      </ds-label>
                      <div :class="$style['copy-inp-wrapper']">
                        <ds-input
                          :value="generatedPassword"
                          :show-error-box="false"
                          type="password"
                          read-only
                          peek-field
                        />
                        <ds-button @click="onCopy(generatedPassword)">SKOPIUJ DO SCHOWKA</ds-button>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="fetchingError">
                  Wystąpił błąd podczas wykonywania komendy.
                </div>
              </ds-loader>
            </div>
          </div>
        </ds-content-box>
      </div>
    </div>
  </div>
</template>

<script>
import ToolboxService from "@/app/dashboard/services/toolbox.service";
import HtpasswdGeneratorForm from "../forms/htpasswd-generator-form";

export default {
  components: {
    HtpasswdGeneratorForm
  },
  data() {
    return {
      fetchingError: false,
      isFetching: false,
      username: "",
      userPassword: "",
      generatedPassword: "",
      user: "",
      password: ""
    };
  },
  computed: {
    breadcrumbs() {
      return {
        top: [
          {
            url: {
              name: "htpasswd-password-generator"
            },
            displayName: "Generator haseł htpasswd"
          }
        ],
        bottom: []
      };
    }
  },
  methods: {
    onCopy(text) {
      this.$copyText(text);
    },
    async onSubmit(username, passwordOptions) {
      this.isFetching = true;
      this.fetchingError = false;
      let resultData;
      this.username = username;

      try {
        this.userPassword = await ToolboxService.generatePassword(
          passwordOptions
        );
        try {
          resultData = await ToolboxService.generateHtpasswd(
            username,
            this.userPassword.data
          );
          this.generatedPassword = resultData.data;
        } catch (e) {
          this.fetchingError = true;
        }
      } catch (e) {
        this.fetchingError = true;
      }

      this.isFetching = false;
    }
  }
};
</script>

<style lang="scss">
.ping-inp {
  span {
    display: none;
  }
}
</style>

<style lang="scss" module>
@import "~@theme/scss/_variables.scss";
@import "~@theme/scss/_mixins.scss";

.wrapper {
  input[name="generated-password"] {
    background-color: #fff !important;
    pointer-events: none !important;
  }
}
.left-column {
  width: 100%;
  margin-right: 20px;
}

.password-response-box {
  display: flex;
  align-items: center;
  div:first-child {
    width: 100%;
    margin-right: 15px;
  }
}
.result-wrapper {
  margin: -10px 0px;
  > * {
    margin: 10px 0px;
  }
}
.copy-inp-wrapper {
  display: flex;
  align-items: center;
  @include mobile() {
    flex-direction: column;
  }
  button {
    @include mobile() {
      margin-top: 15px;
    }
  }
  > span {
    width: 100%;
    margin-right: 15px;
    @include mobile() {
      margin-right: 0px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/app/dashboard/views/htpasswd-password-generator.vue